import React from 'react';
import { TextArea } from '@carbon/react';

export default function TextAreaControl(props) {
  return <TextArea {...props} />;
}
